var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsPlusYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.8075,
    cy: 14.3622,
    r: 13.8075,
    fill: "#F7C412"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4147 13.6777H14.5344V8.79736H12.9076V13.6777H8.02734V15.3044H12.9076V20.1847H14.5344V15.3044H19.4147V13.6777Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPlusYellow);
export default __webpack_public_path__ + "static/media/icons-plus-yellow.b9695c1bd73adf7afd73c51c3e257355.svg";
export { ForwardRef as ReactComponent };